export var RequiredMessage = function RequiredMessage(value) {
  return "".concat(value, "\uC744(\uB97C) \uC785\uB825\uD574\uC8FC\uC138\uC694");
};
export var AgreeMessage = function AgreeMessage(value) {
  return "".concat(value, "\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694");
};
export var SelectMessage = function SelectMessage(value) {
  return "".concat(value, "\uC744(\uB97C) \uC120\uD0DD\uD574\uC8FC\uC138\uC694");
};
export var PASSWORD_VALIDATE_MSG = '비밀번호를 10자 이상 입력해주세요';
export var PASSWORD_UNMATCH_MSG = '비밀번호가 일치하지 않습니다';
export var EMAIL_UNMATCH_MSG = '이메일 형식으로 입력해주세요';
export var UNSIGNED_USER_MSG = '가입되지 않은 사용자입니다';
export var USERNAME_UNMATCH_MSG = '입력하신 아이디와 가입하신 아이디가 일치하지 않습니다.';
export var SIGN_UNMATCH_MSG = '아이디 혹은 비밀번호가 일치하지 않습니다.';
export var USERNAME_OVER_MSG = '아이디는 16자리 이하로 입력해주세요.';
export var PASSWORD_SAME_USERNAME_MSG = '아이디를 비밀번호에 사용할 수 없습니다.';
export var PERSON_MINIMUM_MSG = '최소 1명 이상은 선택해주세요.';
export var CORRECT_DATE_MSG = '정확한 날짜를 입력해주세요';
export var REQUIRED_ORG_NAME = "회사/단체명을 입력해주세요. 개인일 경우, '성함'을 입력해주세요.";
export var CORRECT_PHONE_MSG = '정확한 핸드폰 번호를 입력해주세요. ("-" 문자를 넣어주세요)';
export var ERROR_500 = " \uC774\uC6A9\uC5D0 \uBD88\uD3B8\uC744 \uB4DC\uB824 \uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694.\n \uBB38\uC81C\uAC00 \uBC18\uBCF5\uB420 \uACBD\uC6B0 \uD648\uD398\uC774\uC9C0 \uD558\uB2E8\uC758 \uCC44\uB110\uD1A1\n \uB610\uB294 \uB300\uD45C\uC804\uD654(02.322.8601)\uB97C \uD1B5\uD574 \uBB38\uC758 \uBD80\uD0C1\uB4DC\uB9BD\uB2C8\uB2E4.";
export var ERROR_400 = '비정상적인 접근입니다.';
export var REQUIRED_SPACE_OPTION_MSG = '독립공간 사용여부를 선택해주세요';
export var REQUIRED_SPACE_MSG = '필요한 공간을 체크해주세요';
export var REQUIRED_BANK_MSG = '전용계좌를 개설할 은행을 선택해주세요';
export var REQUIRED_PAYMENT_BANK_MSG = '결제에 필요한 전용계좌를 발급받아주세요';
export var REQUIRED_PAYMENT_CARD_MSG = '결제할 신용카드를 등록해주세요';
export var COMPLETE_MEMBERSHIP_CARD_MSG = '멤버십 신청이 완료되었습니다.';
export var COMPLETE_MEMBERSHIP_BANK_MSG = '멤버십 신청이 완료되었습니다. 발급받으신 계좌로 멤버십 비용을 입금해주세요.';
export var COMPLETE_SPACE_OPTION_MSG = '멤버십 신청이 완료되었습니다. 2영업일 이내로 공간옵션에 관한 안내를 드리겠습니다.';
export var MARKETING_DISAGREE_MSG = '마케팅수신동의를 미동의로 전환합니다. 로컬스티치의 새로운소식이나 행사정보를 받으실 수 없습니다.';
export var MARKETING_AGREE_MSG = '마케팅 정보 수신동의가 처리되었습니다.';
export var PUSH_DISAGREE_MSG = '푸쉬 알림을 끕니다. 로컬스티치로부터 푸쉬 알림을 받지 않습니다.';
export var PUSH_AGREE_MSG = '푸쉬 알림 수신 처리가 완료되었습니다.';